/**
 * This function is for accessing Browser's storage utility
 */
var browserStorageUtil = function(){
	var isStorageSupported = function(){
		if (typeof(Storage) !== "undefined") {
			return true;
		} else {
			//No Support for storage in the browser
			return false;
		}
	}();

	return {
		storeItem:function(itemKey, itemValue){
			try{
				if(isStorageSupported){
					localStorage.setItem(itemKey, itemValue);
				}
			}catch(e){
				if(console)
					console.log(e);
				//while facing exception in storing remove all
			//	browserStorageUtil.clearStorage();
			}
		},
		getStoredItem:function(itemKey){
			try{
				if(isStorageSupported){
					return localStorage.getItem(itemKey);
				}else{
					return null;
				}
			}catch(e){
				if(console)
					console.log(e);
				return null;
			}
		},
		removeItem: function(itemKey){
			try{
				if(isStorageSupported){
					localStorage.removeItem(itemKey);
				}
			}catch(e){
				if(console)
					console.log(e);
			}
		},
		clearStorage: function(){
			try{
				if(isStorageSupported){
					localStorage.clear();	
				}
			}catch(e){
				if(console)
					console.log(e);
			}
		},
		//session storage
		storeSessionItem:function(itemKey, itemValue){
			try{
				if(isStorageSupported){
					sessionStorage.setItem(itemKey, itemValue);
				}
			}catch(e){
				if(console)
					console.log(e);
				//while facing exception in storing remove all
				//browserStorageUtil.clearStorage();
			}
		},
		getStoredSessionItem:function(itemKey){
			try{
				if(isStorageSupported){
					return sessionStorage.getItem(itemKey);
				}else{
					return null;
				}
			}catch(e){
				if(console)
					console.log(e);
				return null;
			}
		},
		removeSessionItem: function(itemKey){
			try{
				if(isStorageSupported){
					sessionStorage.removeItem(itemKey);
				}
			}catch(e){
				if(console)
					console.log(e);
			}
		},
		clearSessionStorage: function(){
			try{
				if(isStorageSupported){
					sessionStorage.clear();	
				}
			}catch(e){
				if(console)
					console.log(e);
			}
		}
	};
}();

export default browserStorageUtil;


// WEBPACK FOOTER //
// ./src/util/BrowserStorageUtil.js